import ComponentErrorBoundary from "@/components/shared/business/ComponentErrorBoundary/ComponentErrorBoundary";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import TableCreatorNavigationTableWrapper from "@FillInTableContainer/shared/components/TableCreatorNavigationTableWrapper/TableCreatorNavigationTableWrapper";

import DealsDealTermsTableCreatorContainer from "./components/DealsDealTermsTableCreatorContainer/DealsDealTermsTableCreatorContainer";
import DealsDealTypeTableCreatorContainer from "./components/DealsDealTypeTableCreatorContainer/DealsDealTypeTableCreatorContainer";
import DealsDrugProfileGroupTable from "./components/DealsDrugProfileGroupTable/DealsDrugProfileGroupTable";
import DealsKeyCommentGroupTable from "./components/DealsKeyCommentGroupTable/DealsKeyCommentGroupTable";
import DealLaScDealTermsGroupTable from "../DealLaScTableCreator/components/DealLaScDealTermsGroupTable/DealLaScDealTermsGroupTable";
import DealLaScKeyCommentGroupTable from "../DealLaScTableCreator/components/DealLaScKeyCommentGroupTable/DealLaScKeyCommentGroupTable";

const DealsTableCreator = () => {
  const errorWithComponent = (title: string) => (
    <TableCreatorGroupTableTitle title={title} isRequired={false} />
  );
  return (
    <TableCreatorNavigationTableWrapper classificationKey="Deals">
      <>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Drug Profile")}
        >
          <DealsDrugProfileGroupTable />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Deal Type & Status")}
        >
          <DealsDealTypeTableCreatorContainer />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Deal Terms")}
        >
          <DealsDealTermsTableCreatorContainer />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Key Comments")}
        >
          <DealsKeyCommentGroupTable />
        </ComponentErrorBoundary>
        {/* NOTE: Deal LA&SC(V2) Deal Terms — LA·Cross·기타 카테고리 담당 (M&A·순수 VF 는 위 V1 이 담당) */}
        <ComponentErrorBoundary
          addComponents={errorWithComponent(
            "Deal Terms & Additional Information",
          )}
        >
          <DealLaScDealTermsGroupTable />
        </ComponentErrorBoundary>
        <ComponentErrorBoundary
          addComponents={errorWithComponent("Key Comments")}
        >
          <DealLaScKeyCommentGroupTable />
        </ComponentErrorBoundary>
      </>
    </TableCreatorNavigationTableWrapper>
  );
};

export default DealsTableCreator;
